import React, {forwardRef, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Tooltip} from "@material-tailwind/react";
import {formatDateString} from "../../utils/daysOptions";
import {ItemInfo} from "../components/ViewData";
import * as IconsFa6 from "react-icons/fa6";
import {useFindPersonLicence} from "../../services/apis/apiPerson";
import {
    PersonLicenceDetailInterface,
    PersonLicenceInterface
} from "../../services/interface/query/person-licence-interface";
import {Person} from "../../services/interface/query/person";

type RefProps = {
    t: any;
    card?: PersonLicenceDetailInterface;
    licence?: PersonLicenceInterface;
    styleIcon?: string
    loadingLicencePerson?: boolean
};

const ComponentWithRef = forwardRef<HTMLSpanElement, RefProps>((
    {t ,card, licence, styleIcon, loadingLicencePerson}
    , ref) => (
    <span ref={ref}>
        <ItemInfo
            label={t('licence')}
            text={`${t('type')}: ${card?.type ? card.type : '-'} ${t('points')}: ${licence?.point ? licence.point : '-'}`}
            icon={<IconsFa6.FaIdCard
                className={styleIcon}/>}
            classNameValue={'uppercase text-[16px]'}
            loading={loadingLicencePerson}
        />
    </span>
));

interface Props {
    styleIcon?: string;
    person?: Person;
}

export default function Licence({person, styleIcon}: Props) {
    const {t} = useTranslation("global") as { t: (key: string) => string };

    const {
        mutate: findLicencePerson,
        isPending: loadingLicencePerson,
        data: successLicencePerson,
    } = useFindPersonLicence()

    const [licence, setLicence] = useState<PersonLicenceInterface | undefined>();

    useEffect(() => {
        if (person && person.identification) {
            setLicence(undefined)
            findLicencePerson({identifier: person.identification})
        }
    }, [person]);

    useEffect(() => {
        if (successLicencePerson) {
            setLicence(successLicencePerson)
        }
    }, [successLicencePerson]);

    const hasCards = licence?.cards && licence.cards.length > 0;

    return (
        <>
            {hasCards ? (
                licence?.cards?.map((item, index) => (
                    <Tooltip
                        key={`licence-${index}`}
                        className="bg-header"
                        content={
                            <div className="flex flex-row gap-3 uppercase">
                                <span className="text-empColorSecondary">{`${t("start-valid")}:`}</span>
                                <span>{formatDateString(item?.startValid)}</span>
                                <span className="text-empColorSecondary">{`${t("end-valid")}:`}</span>
                                <span>{formatDateString(item?.endValid)}</span>
                            </div>
                        }
                    >
                        <ComponentWithRef
                            card={item}
                            {...{ loadingLicencePerson, licence, styleIcon, t }}
                        />
                    </Tooltip>
                ))
            ) : (
                <ItemInfo
                    label={t("licence")}
                    text={"-"}
                    icon={<IconsFa6.FaIdCard className={styleIcon} />}
                    classNameValue="uppercase text-[16px]"
                    loading={loadingLicencePerson}
                />
            )}
        </>
    );
}
